import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AuthenticationService,
  SettingsService,
  DefaultsService,
  EquipmentService,
  SearchService,
} from 'src/app/core/providers';
import { ProfileService } from 'src/app/core/providers/services/profile.service';
import { InputOption } from 'src/app/filters/filter-types/types';
import { TranslateService } from '@ngx-translate/core';
import { ComponentBase } from 'src/app/pages/component.base';
import { NavService } from '../../../core/providers/services/nav.service';
import { FiltersService } from '../../../filters/filters.service';

export const LOCAL_STORAGE_KEY = 'selectedEstimate';
export const DEFAULT_VALUE = 'monthly';

const getValueFromIndex = (index: number | undefined) => {
  switch (index) {
    case 0:
      return 'monthly';
    case 1:
      return 'weekly';
    case 2:
      return 'daily';
    case 3:
      return 'hourly';
    default:
      return 'monthly';
  }
};

@Component({
  selector: 'app-estimate-type',
  templateUrl: './estimate-type.component.html',
  standalone: false,
})
export class EstimateTypeComponent extends ComponentBase implements OnInit {
  options: WritableSignal<InputOption<string>[]> = signal([]);
  selected = signal('monthly');
  hasHourly = signal(false);
  constructor(
    public settingsService: SettingsService,
    public defaultsService: DefaultsService,
    public authenticationService: AuthenticationService,
    public equipmentService: EquipmentService,
    public profileService: ProfileService,
    public searchService: SearchService,
    public navService: NavService,
    public translateService: TranslateService,
    public route: ActivatedRoute,
    public router: Router,
    public filtersService: FiltersService
  ) {
    super(
      defaultsService,
      authenticationService,
      equipmentService,
      profileService,
      searchService,
      navService,
      translateService,
      route,
      router,
      filtersService
    );
  }

  ngOnInit(): void {
    this.authenticationService.startSentryTransaction(
      this.router.routerState.snapshot.url
    );
    this.getState();

    const hourlyFilter = this.filterDefaults?.find(
      (r) => r.CodeName === 'mobile.rate.hourly.show'
    );
    this.hasHourly.set(hourlyFilter?.DefaultValue === 1);
    this.createOptions();
  }

  private getState() {
    console.log('estimate-type.component.ngOnInit ', this.options);

    const storedValue = this.settingsService.getStoredValue(LOCAL_STORAGE_KEY);

    console.log('         storedValue', storedValue);

    const filter = this.filterDefaults?.find(
      (r) => r.CodeName === 'mobile.rate.commission-estimate.value'
    );

    const filterValue = getValueFromIndex(filter?.DefaultValue);

    this.selected.set(storedValue ? storedValue : filterValue);
  }

  private createOptions() {
    const opts = [
      {
        label: this.translateService.instant('main.labels.Monthly'),
        value: 'monthly',
      },
      {
        label: this.translateService.instant('main.labels.Weekly'),
        value: 'weekly',
      },
      {
        label: this.translateService.instant('main.labels.Daily'),
        value: 'daily',
      },
    ];
    if (this.hasHourly()) {
      opts.push({
        label: this.translateService.instant('main.labels.Hourly'),
        value: 'hourly',
      });
    }
    this.options.set(opts);
  }

  onOptionSelect(value: any) {
    console.log('estimate-type.component.onOptionSelect  ', value);
    this.selected.set(value);
    this.settingsService.setStoredValue(LOCAL_STORAGE_KEY, value);
  }

  protected readonly JSON = JSON;
}
